import { render, staticRenderFns } from "./view-meta.vue?vue&type=template&id=2ba8fda2"
import script from "./view-meta.vue?vue&type=script&lang=js"
export * from "./view-meta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports